import { useEffect } from "react";

export const SEO = ({ title, description }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let meta = document.querySelector('meta[name="description"]');
            if (meta) meta.setAttribute("content", description);
            let og = document.querySelector('meta[property="og:title"]');
            if (og && title) og.setAttribute("content", title);
            let ogd = document.querySelector('meta[property="og:description"]');
            if (ogd) ogd.setAttribute("content", description);
        }
    }, [title, description]);
    return null;
};
